export default __webpack_public_path__ + "static/media/element_84.cc3b0862.webp";